import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CommentaireDTO } from "src/app/core/services/business/model/commentaire-dto";
import { CommentaireService } from "src/app/core/services/business/service/commentaire.service";

@Component({
  selector: "app-commentaire-dossier",
  templateUrl: "./commentaire-dossier.component.html",
  styleUrls: ["./commentaire-dossier.component.scss"],
})
export class CommentaireDossierComponent implements OnInit {
  copiedText = "";
  index: Number = 0;

  @Input() requestId: any;
  comments: CommentaireDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _commentaireService: CommentaireService
  ) {
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
  }

  ngOnInit() {
    this.getCommentaires(this.requestId);
  }

  getCommentaires(requestId) {
    this._commentaireService.getCommentaires(requestId).subscribe(
      (data) => {
        this.comments = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onSuccess(e) {
    this.copiedText = e.text;
  }

  onError(e) {
    this.copiedText = "Error trying to copy your text";
  }
}
